import request from '@/utils/request'

// 查询字典类型详细
export function getDictData(dictId) {
  return request({
    url: '/system/dict/data/type/' + dictId,
    method: 'get'
  })
}

export function getAllDicts(){
	return request({
	  url: '/system/dict/data/alllist',
	  method: 'get'
	})
}

export function upload(data){
  return request({
    url:'/common/upload',
    method:'post',
    data:data,
    headers:{'Content-Type':'multipart/form-data'},
    }
  )
}
// 获取用户详细信息
export function getQiuNiuToken() {
  return request({
    url: '/common/getqiniuToken',
    method: 'get'
  })
}


export function delQiuNiuPic(imgsrc){
	const data ={imgsrc}
	return request({
	  url: '/common/qiniu/delimg',
	  method: 'post',
	  data: data
	})
}
// 新增栏目
export function downUrlImgToQiNiu(imgsrc) {
  const data ={imgsrc}
  return request({
    url: '/common/downnetimg',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js